import axios from 'axios';
import Cookies from 'js-cookie';

import { getApiUrl, getDomain, formatAndThrowApiError } from '@/helpers/api';

export const usePostLogin = () => {
  const postLogin = async (payload) => {
    try {
      const url = `${getApiUrl()}/login/mega`;
      const response = await axios.post(url, payload);
      Cookies.set(`token`, response.data.token, { domain: getDomain() });
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return postLogin;
};
